import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'
import { injectIntl, FormattedMessage } from 'react-intl'
import _uniqueId from 'lodash/uniqueId'
import { actions as featuredItemsActions } from '@knowledgehound/stories/featuredItems'

import ModalControls from './ModalControls'
import * as modalStyles from './Modal.module.scss'

class AddToStudy extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    content_object: PropTypes.object.isRequired,
    content_type: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    study: PropTypes.object.isRequired,
    onCreateError: PropTypes.func.isRequired,
    onClickViewStudy: PropTypes.func,
    handleClose: PropTypes.func.isRequired,
    successMessage: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      addToStudyErr: null,
      title: ''
    }
  }

  closeModal = () => {
    this.setState({ title: '' })
    this.props.handleClose()
  }

  handleChange = (evt) => {
    this.setState({
      title: evt.currentTarget.value
    })
  }

  handleSubmit = (evt) => {
    evt.preventDefault()
    this.closeModal()
    const {
      dispatch,
      content_type,
      content_object,
      study,
      onCreateError,
      onClickViewStudy
    } = this.props

    const { title } = this.state

    const newContentItem = {
      title,
      content_type,
      content_object,
    }

    if (study && study.study_number) {
      dispatch(featuredItemsActions.createFeaturedItem(newContentItem, study.study_number))
        .then(() => {
          window.analytics.track('Add Featured Item To Study', {
            study: study.study_number,
            title: title,
          })
          if (study) {
            this.props.successMessage(
              `Card was added to ${study.study_name || ""}`,
              {
                action: 'View',
                onClick: () => {
                  if (study.study_number) {
                    if (onClickViewStudy) {
                      return onClickViewStudy(study.study_number)
                    } else {
                      window.location.assign(`/studies/${study.study_number}`)
                    }
                  }
                }
              }
            )
          }
        })
        .catch((err) => {
          this.setState({ addToStudyErr: err })
          this.context.sendNotification(
            _uniqueId('_addToStoryModal'),
            'error',
            `There was an error adding this Featured Item to the Study Dashboard, please try again.  If the error persists please contact customer support.`,
            {
              action: 'Try Again',
              onClick: onCreateError,
            }
          )
          Sentry.captureException(new Error('Error occurred while creating a card', { cause: err }))
        })
    }
  }

  render () {
    const { intl } = this.props
    const { addToStudyErr, title } = this.state

    return (
      <section>
        {addToStudyErr && (
          <p className={modalStyles.errorMessage}>
            <FormattedMessage id="addToStory.newInsightError" />
          </p>
        )}
        <form
          className={modalStyles.addForm}
          onSubmit={this.handleSubmit}
          name="add-to-story"
          action="."
        >
          <label
            className={modalStyles.label}
            htmlFor="insightDescription"
          >
            <FormattedMessage id="addToStory.descriptionLabel" />
          </label>
          <textarea
            className={modalStyles.descriptionField}
            name="insightDescription"
            id="insightDescription"
            placeholder={intl.formatMessage({
              id: 'addToStory.descriptionPlaceholder'
            })}
            onChange={this.handleChange}
            maxLength={300}
          />
          <ModalControls
            onCancel={this.closeModal}
            submitDisabled={!title}
          />
        </form>
      </section>
    )
  }
}

export default injectIntl(AddToStudy)
